import React from 'react'
import { StyledIcon } from '../StyledIcon'

const BrandLogoFavicon = ({ icon, size, customProps }) => (
  <StyledIcon a11yTitle={icon} color="plain" size={size} {...customProps}>
    <path
      fill="#2E4787"
      d="M8.022,41.354c-1.55-1.55-2.403-3.61-2.403-5.802c0-2.192,0.853-4.252,2.403-5.802
c1.55-1.549,3.61-2.403,5.802-2.403h20.512c1.722,0,3.341-0.67,4.558-1.888c1.218-1.218,1.888-2.837,1.888-4.559
c0-1.722-0.671-3.341-1.888-4.559c-1.218-1.218-2.836-1.888-4.558-1.888H23.017l-1.868,4.982h13.186
c0.808,0,1.465,0.657,1.465,1.465s-0.657,1.465-1.465,1.465H13.824c-1.777,0-3.505,0.35-5.134,1.039
c-1.571,0.664-2.981,1.614-4.19,2.824c-1.209,1.209-2.159,2.618-2.824,4.189c-0.689,1.629-1.039,3.357-1.039,5.134
c0,1.777,0.349,3.505,1.039,5.134c0.665,1.571,1.614,2.981,2.824,4.19c1.209,1.209,2.619,2.159,4.19,2.823
c1.629,0.689,3.357,1.039,5.134,1.039h8.791l1.868-4.981H13.824C11.632,43.757,9.572,42.903,8.022,41.354"
    />
    <path
      fill="#2E4787"
      d="M46.483,15.766c-0.664-1.571-1.614-2.981-2.823-4.189c-1.209-1.209-2.619-2.159-4.19-2.824
c-1.629-0.689-3.357-1.039-5.134-1.039h-8.791l-1.868,4.981h10.659c2.191,0,4.252,0.854,5.802,2.403
c1.549,1.55,2.403,3.61,2.403,5.802s-0.854,4.252-2.403,5.802c-1.55,1.549-3.61,2.403-5.802,2.403H13.824
c-1.722,0-3.341,0.671-4.558,1.888c-1.218,1.218-1.888,2.836-1.888,4.559c0,1.722,0.671,3.341,1.888,4.558
c1.218,1.218,2.836,1.888,4.558,1.888h11.318l1.868-4.981H13.824c-0.808,0-1.465-0.657-1.465-1.465c0-0.808,0.657-1.465,1.465-1.465
h20.512c1.777,0,3.505-0.349,5.134-1.039c1.571-0.664,2.98-1.614,4.19-2.823c1.209-1.209,2.159-2.619,2.823-4.19
c0.689-1.629,1.039-3.357,1.039-5.134C47.521,19.123,47.172,17.396,46.483,15.766"
    />
    <path
      fill="#2E4787"
      d="M116.603,22.696h-4.936c-5.276,0-9.859,3.634-11.099,8.715l-2.299,11.796h6.704l1.944-10.008
c0.441-2.269,2.439-3.916,4.75-3.916h3.677L116.603,22.696z"
    />
    <path
      fill="#2E4787"
      d="M56.904,32.555c1.22-6.181,6.587-10.166,12.89-10.166c5.733,0,9.352,3.497,8.702,8.336h-6.831
c-0.041-1.545-1.261-2.643-3.375-2.643c-1.992,0-4.066,1.505-4.636,4.473c-0.569,3.09,0.976,5.286,3.497,5.286
c1.83,0,3.09-1.139,3.7-2.684h6.994c-1.057,4.92-6.425,8.376-11.385,8.376C59.75,43.533,55.684,38.735,56.904,32.555"
    />
    <path
      fill="#2E4787"
      d="M84.601,43.533c-0.006,0-0.011,0-0.016,0c-0.005,0-0.01,0-0.015,0H84.601z"
    />
    <path
      fill="#2E4787"
      d="M90.099,22.389c-4.268,0-7.807,2.06-9.426,4.85l5.236,2.406c0.49-1.275,2.011-2.67,3.715-2.67
c1.913,0,2.66,1.048,2.338,2.459c-0.202,0.806-0.806,1.29-1.733,1.29l-3.726,0.001c-3.553,0-7.024,1.653-7.809,5.743
c-0.743,3.755,1.976,7.056,5.81,7.065c2.635-0.005,4.54-1.182,5.393-2.887l-0.488,2.562h6.669l2.48-12.768
C99.451,25.805,95.751,22.389,90.099,22.389 M90.912,35.624c-0.325,1.792-1.992,3.233-3.618,3.233c-1.626,0-2.398-0.935-2.154-2.103
c0.244-1.169,1.26-1.597,2.439-1.597h3.414L90.912,35.624z"
    />
    <path
      fill="#2E4787"
      d="M130.922,22.389c-2.521,0-4.432,0.773-5.855,2.074l0.332-1.766h-6.713l-5.076,26.041h6.714l1.327-6.75
c0.935,0.935,3.05,1.545,5.367,1.545c5.693,0,9.962-4.026,11.141-10.165C139.38,27.147,135.965,22.389,130.922,22.389
M131.532,32.799c-0.488,2.846-2.602,5.001-5.042,5.083c-2.48,0.082-3.944-1.952-3.456-4.757c0.488-2.846,2.643-5.001,5.083-5.083
C130.556,27.96,132.02,29.993,131.532,32.799"
    />
    <path
      fill="#2E4787"
      d="M176.592,22.696h-4.936c-5.276,0-9.859,3.634-11.099,8.715l-2.299,11.796h6.704l1.944-10.008
c0.441-2.269,2.439-3.916,4.75-3.916h3.677L176.592,22.696z"
    />
    <path
      fill="#2E4787"
      d="M144.525,43.533c-0.006,0-0.011,0-0.016,0c-0.005,0-0.01,0-0.015,0H144.525z"
    />
    <path
      fill="#2E4787"
      d="M150.105,22.389c-4.268,0-7.808,2.06-9.426,4.85l5.235,2.406c0.49-1.275,2.011-2.67,3.715-2.67
c1.913,0,2.66,1.048,2.338,2.459c-0.202,0.806-0.807,1.29-1.733,1.29l-3.725,0.001c-3.553,0-7.024,1.653-7.809,5.743
c-0.742,3.755,1.976,7.056,5.81,7.065c2.635-0.005,4.541-1.182,5.393-2.887l-0.488,2.562h6.669l2.48-12.768
C159.457,25.805,155.757,22.389,150.105,22.389 M150.918,35.624c-0.325,1.792-1.992,3.233-3.618,3.233
c-1.626,0-2.399-0.935-2.154-2.103c0.244-1.169,1.26-1.597,2.439-1.597H151L150.918,35.624z"
    />
    <path
      fill="#2E4787"
      d="M189.197,36.173h5.652c-0.122,1.464,1.261,2.44,3.009,2.44c1.505,0,2.684-0.651,2.684-1.667
c0-2.806-9.556,0.163-9.556-7.4c0-4.066,4.676-7.156,9.149-7.156c4.92,0,8.214,2.846,7.726,6.872h-5.693
c0.041-1.382-1.261-2.358-2.643-2.358c-1.423,0-2.439,0.651-2.439,1.83c0,2.887,9.84-0.447,9.84,7.075
c0,4.595-4.107,7.726-9.637,7.726C192.165,43.533,188.669,40.321,189.197,36.173"
    />
    <path
      fill="#2E4787"
      d="M184.319,28.245h5.164l1.06-5.548h-5.164l1.08-5.517h-6.709l-3.605,18.587c-0.935,4.636,1.87,7.441,6.465,7.441
h3.944l1.098-5.53h-2.927c-1.301,0-2.074-0.813-1.789-2.236L184.319,28.245z"
    />
    <polygon
      fill="#F47920"
      points="212.122,39.641 211.429,43.207 207.69,43.207 208.383,39.641 "
    />
    <path
      fill="#F47920"
      d="M213.954,35.938c0.832-4.216,4.493-6.934,8.792-6.934c3.911,0,6.379,2.385,5.935,5.686h-4.66
c-0.028-1.054-0.86-1.803-2.302-1.803c-1.359,0-2.773,1.026-3.162,3.051c-0.388,2.108,0.666,3.606,2.385,3.606
c1.248,0,2.108-0.777,2.524-1.831h4.77c-0.721,3.356-4.382,5.714-7.766,5.714C215.896,43.427,213.122,40.154,213.954,35.938"
    />
    <path
      fill="#F47920"
      d="M229.901,37.436c-0.194-4.798,3.605-8.431,8.459-8.431c3.8,0,6.573,2.635,6.685,5.991
c0.194,4.798-3.606,8.431-8.459,8.431C232.785,43.427,230.012,40.792,229.901,37.436 M240.44,35.55c0-1.636-0.971-2.663-2.496-2.663
c-2.136,0-3.439,1.969-3.439,3.994c0,1.636,0.971,2.663,2.496,2.663C239.137,39.544,240.44,37.575,240.44,35.55"
    />
    <path
      fill="#F47920"
      d="M248.344,29.228h4.576l-0.332,1.664c1.054-1.109,2.469-1.886,4.243-1.886c2.136,0,3.217,0.832,3.661,2.358
c0.998-1.221,2.912-2.358,4.937-2.358c3.328,0,4.881,2.33,4.271,5.464l-1.692,8.737h-4.576l1.526-7.821
c0.305-1.553-0.361-2.552-1.664-2.552c-1.304,0-2.358,0.998-2.662,2.552l-1.526,7.821h-4.577l1.525-7.821
c0.305-1.553-0.361-2.552-1.664-2.552c-1.304,0-2.358,0.998-2.663,2.552l-1.526,7.821h-4.576L248.344,29.228z"
    />
    <g>
      <g>
        <path d="M269.898,25.103V24.51h3.528v0.592h-1.422v3.968h-0.687v-3.968H269.898z" />
        <path
          d="M274.204,24.51h0.835l1.451,3.545h0.054l1.452-3.545h0.835v4.56h-0.655v-3.3h-0.042l-1.345,3.293h-0.543l-1.345-3.295
  h-0.043v3.302h-0.654V24.51z"
        />
      </g>
    </g>
  </StyledIcon>
)

export default BrandLogoFavicon
